module.exports = "<header>\n  <div class=\"inner\">\n    <div class=\"logo\"></div>\n    <span class=\"beta-badge\">beta</span>\n  </div>\n</header>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header/header.component.html
// module id = ./src/app/components/header/header.component.html
// module chunks = main